var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnecter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.987174 37.0473C0.944395 37.0473 0.944395 37.0473 0.901615 37.0473C0.345479 37.0045 -0.0395384 36.5339 0.00324131 36.0206C0.559378 27.8496 8.25973 21.4755 17.5001 21.4755C26.7406 21.4755 34.4409 27.8496 34.997 35.9778C35.0398 36.5339 34.612 36.9617 34.0987 37.0045C33.5425 37.0473 33.1147 36.6195 33.072 36.1061C32.5586 28.9619 25.7138 23.4006 17.5001 23.4006C9.24366 23.4006 2.39891 29.0047 1.92833 36.1489C1.88555 36.6623 1.45775 37.0473 0.987174 37.0473Z",
    fill: "#2E8B57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 19.5075C12.1096 19.5075 7.74609 15.144 7.74609 9.75377C7.74609 4.36353 12.1096 0 17.4999 0C22.8901 0 27.2536 4.36353 27.2536 9.75377C27.2536 15.144 22.8901 19.5075 17.4999 19.5075ZM17.4999 1.96787C13.2219 1.96787 9.71396 5.4758 9.71396 9.75377C9.71396 14.0317 13.2219 17.5397 17.4999 17.5397C21.7778 17.5397 25.2858 14.0317 25.2858 9.75377C25.2858 5.4758 21.7778 1.96787 17.4999 1.96787Z",
    fill: "#2E8B57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecter);
export default __webpack_public_path__ + "static/media/connecter.ec26e3c7099db5f8bd0f1d7a9e3170c2.svg";
export { ForwardRef as ReactComponent };